export const MessageType = { // eslint-disable-line import/prefer-default-export
    QUERY_LATEST: 0,
    QUERY_ALL: 1,
    RESPONSE_BLOCKCHAIN: 2
};